//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import "@/mixins/global";
import chartOTP from "../components/chartOTP";
import axios, { CancelToken } from "axios";
import ChartOTP from "../components/chartOTP.vue";
export default {
  components: {
    chartOTP,
  },
  data() {
    return {
      chartNONNIKEDoc: {
        ALL: [],
        TLA11: [],
        TLA12: [],
        TLA21: [],
        TLA22: [],
        TLA31: [],
        TLA32: [],
        TLA41: [],
        TVN11: [],
      },
      chartNONNIKESample: {
        ALL: [],
        TLA11: [],
        TLA12: [],
        TLA21: [],
        TLA22: [],
        TLA31: [],
        TLA32: [],
        TLA41: [],
        TVN11: [],
      },

      ps: "202040",
      pe: "202052",
      apinonnike_doc: `${this.$apiFix}OTP_NONNIKE.php/th_nonnike_doc`,
        // "http://localhost:9000/nygcontrolroom/OTP_NONNIKE.php/th_nonnike_doc",
      apinonnike_sample: `${this.$apiFix}OTP_NONNIKE.php/th_nonnike_sample`,
        // "http://localhost:9000/nygcontrolroom/OTP_NONNIKE.php/th_nonnike_sample",
    };
  },
  async mounted() {
    this.nonnikeDoc();
    this.nonnikeSample();
  },
  methods: {
    goPage(routerName) {
      this.$router.push({
        name: routerName,
      });
    },

    nonnikeDoc() {
      axios
        .get(`${this.apinonnike_doc}?ps=${this.ps}&pe=${this.pe}&team=`)
        .then((response) => {
          this.chartNONNIKEDoc.ALL = response.data;
        });
      axios
        .get(`${this.apinonnike_doc}?ps=${this.ps}&pe=${this.pe}&team=TLA1-1`)
        .then((response) => {
          this.chartNONNIKEDoc.TLA11 = response.data;
        });
      axios
        .get(`${this.apinonnike_doc}?ps=${this.ps}&pe=${this.pe}&team=TLA1-2`)
        .then((response) => {
          this.chartNONNIKEDoc.TLA12 = response.data;
        });
      axios
        .get(`${this.apinonnike_doc}?ps=${this.ps}&pe=${this.pe}&team=TLA2-1`)
        .then((response) => {
          this.chartNONNIKEDoc.TLA21 = response.data;
        });
      axios
        .get(`${this.apinonnike_doc}?ps=${this.ps}&pe=${this.pe}&team=TLA2-2`)
        .then((response) => {
          this.chartNONNIKEDoc.TLA22 = response.data;
        });
      axios
        .get(`${this.apinonnike_doc}?ps=${this.ps}&pe=${this.pe}&team=TLA3-1`)
        .then((response) => {
          this.chartNONNIKEDoc.TLA31 = response.data;
        });
      axios
        .get(`${this.apinonnike_doc}?ps=${this.ps}&pe=${this.pe}&team=TLA3-2`)
        .then((response) => {
          this.chartNONNIKEDoc.TLA32 = response.data;
        });
      axios
        .get(`${this.apinonnike_doc}?ps=${this.ps}&pe=${this.pe}&team=TLA4-1`)
        .then((response) => {
          this.chartNONNIKEDoc.TLA41 = response.data;
        });
      axios
        .get(`${this.apinonnike_doc}?ps=${this.ps}&pe=${this.pe}&team=TVN1-1`)
        .then((response) => {
          this.chartNONNIKEDoc.TVN11 = response.data;
        });
    },
    nonnikeSample() {
      axios
        .get(`${this.apinonnike_sample}?ps=${this.ps}&pe=${this.pe}&team=`)
        .then((response) => {
          this.chartNONNIKESample.ALL = response.data;
        });
      axios
        .get(`${this.apinonnike_sample}?ps=${this.ps}&pe=${this.pe}&team=TLA1-1`)
        .then((response) => {
          this.chartNONNIKESample.TLA11 = response.data;
        });
      axios
        .get(`${this.apinonnike_sample}?ps=${this.ps}&pe=${this.pe}&team=TLA1-2`)
        .then((response) => {
          this.chartNONNIKESample.TLA12 = response.data;
        });
      axios
        .get(`${this.apinonnike_sample}?ps=${this.ps}&pe=${this.pe}&team=TLA2-1`)
        .then((response) => {
          this.chartNONNIKESample.TLA21 = response.data;
        });
      axios
        .get(`${this.apinonnike_sample}?ps=${this.ps}&pe=${this.pe}&team=TLA2-2`)
        .then((response) => {
          this.chartNONNIKESample.TLA22 = response.data;
        });
      axios
        .get(`${this.apinonnike_sample}?ps=${this.ps}&pe=${this.pe}&team=TLA3-1`)
        .then((response) => {
          this.chartNONNIKESample.TLA31 = response.data;
        });
      axios
        .get(`${this.apinonnike_sample}?ps=${this.ps}&pe=${this.pe}&team=TLA3-2`)
        .then((response) => {
          this.chartNONNIKESample.TLA32 = response.data;
        });
      axios
        .get(`${this.apinonnike_sample}?ps=${this.ps}&pe=${this.pe}&team=TLA4-1`)
        .then((response) => {
          this.chartNONNIKESample.TLA41 = response.data;
        });
      axios
        .get(`${this.apinonnike_sample}?ps=${this.ps}&pe=${this.pe}&team=TVN1-1`)
        .then((response) => {
          this.chartNONNIKESample.TVN11 = response.data;
        });
    },
  },
};
